import React, { useState, useEffect, useRef, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import '../src/Utility/Public/css/toastify.css';
import '../src/Utility/Public/css/Left.scss';
import '../src/Utility/Public/css/theme.css';
import '../src/Utility/Public/css/headerdoc.scss';
import '../src/Utility/Public/css/headerresponsivedoc.scss';
import logger from './logger';
import "./i18n";
import { ToastContainer } from 'react-toastify';
import '../src/Utility/Public/css/commonresponsive.scss';
import 'react-image-crop/dist/ReactCrop.css';
import suneditorCss from 'suneditor/dist/css/suneditor.min.css';
window.__suneditorCssLoaded = suneditorCss;


const root = ReactDOM.createRoot(document.getElementById('root'));
const persistor = persistStore(store);
// Disable console.log when pointing to staging or production APIs
const noLogUrls = ['https://api.stage.mettastay.com/', 'https://api.mettastay.com/'];
if (noLogUrls.includes(process.env.BASE_URL)) {
  console.log = () => {};
}

root.render(
  <React.StrictMode>
    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={false}>
          <App />
        </Suspense>
      </PersistGate>
    </Provider>
    <ToastContainer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Enable Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept('./App', () => {
    // Re-render the app when App.js changes
    const NextApp = require('./App').default;
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={false}>
              <NextApp />
            </Suspense>
          </PersistGate>
        </Provider>
        <ToastContainer />
      </React.StrictMode>
    );
  });
}   